"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProfileSchema = exports.TIME_ZONES = void 0;
const zod_1 = require("zod");
const E164 = /^\+[1-9]\d{1,14}$/;
const AVATAR_KEY = /^avatars\/[0-9a-f-]{36}\/[0-9a-f-]{36}\.(png|jpe?g|webp)$/i;
exports.TIME_ZONES = (() => {
    const intl = Intl;
    if (typeof intl.supportedValuesOf === 'function') {
        return intl.supportedValuesOf('timeZone');
    }
    return ['UTC'];
})();
const TIME_ZONE_SET = new Set(exports.TIME_ZONES);
const fullName = zod_1.z
    .string()
    .nullable()
    .transform((v) => {
    if (v === null)
        return null;
    const trimmed = v.trim();
    return trimmed.length === 0 ? null : trimmed;
})
    .refine((v) => v === null || v.length <= 80, {
    message: 'Display name must be 80 characters or fewer.',
});
const phone = zod_1.z
    .string()
    .nullable()
    .transform((v) => {
    if (v === null)
        return null;
    const stripped = v.replace(/[^\d+]/g, '');
    return stripped === '' ? null : stripped;
})
    .refine((v) => v === null || E164.test(v), {
    message: 'Phone must include the country code (e.g. +491701234567).',
});
const timeZone = zod_1.z
    .string()
    .nullable()
    .refine((v) => v === null || TIME_ZONE_SET.has(v), {
    message: 'Pick a time zone from the list.',
});
const avatarKey = zod_1.z
    .string()
    .nullable()
    .refine((v) => v === null || AVATAR_KEY.test(v), {
    message: 'Invalid avatar reference.',
});
exports.updateProfileSchema = zod_1.z
    .object({
    fullName: fullName.optional(),
    phone: phone.optional(),
    timeZone: timeZone.optional(),
    avatarKey: avatarKey.optional(),
})
    .strict();
//# sourceMappingURL=update-profile.schema.js.map